import * as React from 'react';
import { Dropdown } from 'semantic-ui-react';
import styles from './OpenMenuComponent.module.scss';

interface IOpenMenuComponentProps { }
interface IOpenMenuComponentState {
    isMenuOpen: boolean;
}

export class OpenMenuComponent extends React.Component<IOpenMenuComponentProps, IOpenMenuComponentState> {
    constructor(props: IOpenMenuComponentProps) {
        super(props);
        this.state = {
            isMenuOpen: false
        }

    }

    public render() {
        return (
            <div onClick={() => this.onSelect()}>
                <Dropdown item icon='ellipsis vertical' disabled>
                    <Dropdown.Menu className={styles.openMenu}>
                        <Dropdown.Header>Text Size</Dropdown.Header>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }

    private onSelect() {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }
}